import script from "./BenchmarkView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenchmarkView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__